// src/components/common/PrivateRoute.jsx
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from './LoadingSpinner';

const PrivateRoute = ({ roles = [], requiredFeature = null }) => {
    const { user, loading, isAuthenticated, hasFeature } = useAuth();
    const location = useLocation();

    if (loading) return <LoadingSpinner fullScreen />;

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Controllo ruolo
    if (roles.length > 0 && !roles.includes(user?.role)) {
        return <Navigate to="/dashboard" replace />;
    }

    // Controllo feature piano
    if (requiredFeature && !hasFeature(requiredFeature)) {
        return <Navigate to="/settings?tab=plan" replace />;
    }

    return <Outlet />;
};

export default PrivateRoute;